module.exports = __webpack_public_path__ + "img/footer-other.22c8d666.png";